<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer" v-if="!toBStockoutOrderId">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-page>
    <el-dialog title="手工放行" width="550px" :visible.sync="showFormDialog">
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="核注单编号">
          <el-input v-model="formData.businessId"></el-input>
        </el-form-item>
        <el-form-item label="单一窗口编号">
          <el-input v-model="formData.singleWindowNo"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveManualDeclare">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import heZhuApi from "@/api/heZhuApi";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  watch: {
    $route: {
      handler() {
        this.returnDeclareOrderId = this.$route.params.returnDeclareOrderId;
        this.fetch();
      },
      immediate: true
    }
  },
  data() {
    return {
      uploadData: {
        _aid: 401
      },
      showFormDialog: false,
      manualDeclareHeZhuId: null,
      formData: {},
      returnDeclareOrderId: null,
      loading: false,
      dataList: [],
      columns: [
        {
          title: "核注清单编号",
          key: "copListNo",
          width: 200,
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <a
                style={{ color: "#409EFF", padding: "0 10px" }}
                onClick={this.jumpToDetailPage.bind(this, row)}
              >
                {row.copListNo}
              </a>
            );
          }
        },
        {
          title: "海关清单编号",
          key: "businessId",
          width: 150,
          align: "center"
        },
        {
          title: "单一窗口号",
          key: "singleWindowNo",
          width: 200,
          align: "center"
        },
        {
          title: "账册号",
          key: "emsNo",
          width: 150,
          align: "center"
        },
        {
          title: "清单类型",
          key: "billType",
          width: 100,
          align: "center"
        },
        {
          title: "经营企业",
          key: "bizOpCompany",
          width: 200,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.bizOpCompanyName}</el-tag>
                <el-tag size="mini">{row.bizOpCompanyNo}</el-tag>
                <el-tag size="mini">{row.bizOpCompanyCreditNo}</el-tag>
              </div>
            );
          }
        },
        {
          title: "收货企业",
          key: "rcvCompany",
          width: 200,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.rcvCompanyName}</el-tag>
                <el-tag size="mini">{row.rcvCompanyNo}</el-tag>
                <el-tag size="mini">{row.rcvCompanyCreditNo}</el-tag>
              </div>
            );
          }
        },
        {
          title: "申报企业",
          key: "dclCompany",
          width: 200,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.dclCompanyName}</el-tag>
                <el-tag size="mini">{row.dclCompanyNo}</el-tag>
                <el-tag size="mini">{row.dclCompanyCreditNo}</el-tag>
              </div>
            );
          }
        },
        {
          title: "监管方式",
          key: "tradeMode",
          width: 100,
          align: "center"
        },
        {
          title: "运输方式",
          key: "transMode",
          width: 100,
          align: "center"
        },
        {
          title: "起运国",
          key: "startShipCountry",
          width: 100,
          align: "center"
        },
        {
          title: "关联账册备案编号",
          key: "rltEmsNo",
          width: 200,
          align: "center"
        },
        {
          title: "关联清单编号",
          key: "rltInvtNo",
          width: 200,
          align: "center"
        },
        {
          title: "申报状态",
          width: 200,
          key: "status",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待申报"],
              DECLARED: ["warning", "已申报"],
              DECLARE_SUCCESS: ["success", "申报成功"],
              DECLARE_FAIL: ["error", "申报失败"]
            };
            return (
              <div>
                <el-tag type={tagType[row.status][0]}>
                  {tagType[row.status][1]}
                </el-tag>
              </div>
            );
          }
        },
        {
          title: "状态描述",
          width: 200,
          key: "statusDesc",
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.declare.bind(this, row)}
                >
                  申报
                </a>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.manualDeclareSuccess.bind(this, row)}
                >
                  手工放行
                </a>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.delete.bind(this, row)}
                >
                  删除
                </a>
              </div>
            );
          }
        }
      ],
      filterObj: {
        outBizId: "",
        bizId: ""
      },
      currentRow: []
    };
  },
  methods: {
    jumpToDetailPage(row) {
      this.$router.push({
        name: "returnDeclareOrderHeZhuOrderDetail",
        params: { heZhuOrderId: row.id }
      });
    },
    manualDeclareSuccess(row) {
      this.manualDeclareHeZhuId = row.id;
      this.formData = {};
      this.showFormDialog = true;
    },
    saveManualDeclare() {
      this.$confirm("此操作将手工放行核注单, 请确认数据正确", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        heZhuApi
          .manualDeclareSuccess({
            request: {
              id: this.manualDeclareHeZhuId,
              singleWindowNo: this.formData.singleWindowNo,
              businessId: this.formData.businessId
            }
          })
          .then(res => {
            if (res.value) {
              this.$message({
                type: "success",
                message: "申报成功!"
              });
            } else {
              this.$message({
                type: "error",
                message: res.resultMessage
              });
            }
            this.fetch();
          });
      });
    },
    declare(row) {
      this.$confirm("此操作将申报核注单, 请确认数据正确", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        heZhuApi
          .declare({
            heZhuOrderId: row.id
          })
          .then(res => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "申报成功!"
              });
            } else {
              this.$message({
                type: "error",
                message: res.resultMessage
              });
            }
            this.fetch();
          });
      });
    },
    delete(row) {
      this.$confirm("此操作将删除核注单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        heZhuApi
          .delete({
            heZhuOrderId: row.id
          })
          .then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.fetch();
          });
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        let start = filterParams.applyTime[0] + " 00:00:00",
          end = filterParams.applyTime[1] + " 23:59:59";
        filterParams.gmtCreateStart = new Date(start).getTime();
        filterParams.gmtCreateEnd = new Date(end).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }
      let searchCondition = {
        ...filterParams,
        bizId: this.$route.params.returnDeclareOrderId,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        type: "RETURN"
      };
      heZhuApi.list({ request: searchCondition }).then(res => {
        this.dataList = res.items;
        this.pagination.currentPage = res.page.pageIndex;
        this.pagination.pageSize = res.page.pageSize;
        this.pagination.totalCount = res.page.totalCount;
        this.loading = false;
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      if (this.$route.params.bizId) {
        return null;
      }
      return [];
    }
  }
};
</script>

<style>
.avatar-uploader {
  display: inline-block;
}

.inline-p {
  display: inline-block;
}

.inline-p span {
  color: #3399ff;
}

.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
